/* fiveaven : titres des vignettes produit. Règle d'Andy (16/10/2026) : un titre de plus de 3 mots qui tient sur une seule
   ligne passe sur deux lignes, coupé entre les deux mots qui équilibrent le mieux les lignes ; un titre déjà sur plusieurs
   lignes reste tel quel. Toutes les cartes (.card-product), y compris celles ajoutées au défilement ; recalcul au redimensionnement. */
(function () {
  "use strict";
  if (window.fvTitres) return;
  var SEL = ".card-product .x-card-title";
  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); };
  // nombre de lignes réellement affichées (0 si la carte est masquée)
  function lignes(a) {
    var r = document.createRange(), hauts = [];
    r.selectNodeContents(a);
    [].forEach.call(r.getClientRects(), function (b) {
      if (b.width < 1) return;
      var t = Math.round(b.top);
      if (!hauts.some(function (x) { return Math.abs(x - t) < 4; })) hauts.push(t);
    });
    return hauts.length;
  }
  /* fiveaven : un lot de titres est traité en passes séparées (écritures, puis toutes les mesures, puis les coupes, puis
     toutes les vérifications) au lieu de mesurer et modifier carte par carte : 2 mises en page pour tout le lot au lieu
     d'une ou deux par carte. Même résultat : la largeur d'une carte ne dépend pas du titre des autres. */
  function traiterLot(liste) {
    var aMesurer = [];
    liste.forEach(function (a) { // 1. texte d'origine (un titre déjà coupé est remis d'un seul tenant)
      var orig = a.getAttribute("data-fv-titre");
      if (orig == null) { orig = a.textContent.replace(/\s+/g, " ").trim(); a.setAttribute("data-fv-titre", orig); }
      else if (a.querySelector("br.fv-coupe")) a.textContent = orig;
      var mots = orig.split(" ");
      if (mots.length > 3) aMesurer.push({ a: a, orig: orig, mots: mots });
    });
    // 2. mesures groupées : seuls les titres sur une seule ligne sont coupés
    var aCouper = aMesurer.filter(function (x) { return lignes(x.a) === 1; });
    aCouper.forEach(function (x) { // 3. coupe entre les deux mots qui équilibrent le mieux les lignes
      var mots = x.mots, coupe = 1, ecart = Infinity;
      for (var k = 1; k < mots.length; k++) {
        var e = Math.abs(mots.slice(0, k).join(" ").length - mots.slice(k).join(" ").length);
        if (e < ecart) { ecart = e; coupe = k; }
      }
      x.a.innerHTML = esc(mots.slice(0, coupe).join(" ")) + '<br class="fv-coupe">' + esc(mots.slice(coupe).join(" "));
    });
    // 4. vérification groupée, puis 5. retour au titre d'origine s'il dépasse 2 lignes
    aCouper.filter(function (x) { return lignes(x.a) > 2; }).forEach(function (x) { x.a.textContent = x.orig; });
  }
  var file = [], prevu = false;
  function planifier(a) {
    if (file.indexOf(a) < 0) file.push(a);
    if (prevu) return;
    prevu = true;
    requestAnimationFrame(function () { prevu = false; var l = file; file = []; traiterLot(l); });
  }
  function tout() { document.querySelectorAll(SEL).forEach(planifier); }
  new MutationObserver(function (ms) {
    ms.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.matches(SEL)) planifier(n);
        n.querySelectorAll(SEL).forEach(planifier);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
  var largeur = window.innerWidth, minuteur = null;
  window.addEventListener("resize", function () {
    if (window.innerWidth === largeur) return;
    largeur = window.innerWidth; clearTimeout(minuteur); minuteur = setTimeout(tout, 150);
  });
  tout();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(tout);
  window.fvTitres = { recalculer: tout };
})();

/* fiveaven, DA 2 : une traduction coréenne (.fv-kr) qui tombe à la ligne sous son titre (titre long, « Devenez ambassadeur »
   du pied de page) reçoit la classe fv-kr--dessous : elle est remontée juste sous le titre au lieu de laisser un interligne
   entier. Sur mobile elle est toujours dessous (CSS). Mesures groupées puis écritures ; recalcul au redimensionnement. */
(function () {
  "use strict";
  if (window.fvKr) return;
  window.fvKr = true;
  function placer() {
    var ks = [].slice.call(document.querySelectorAll(".fv-kr"));
    ks.forEach(function (k) { k.classList.remove("fv-kr--dessous"); });
    if (matchMedia("(max-width: 767px)").matches) return;
    ks.filter(function (k) {
      if (!k.offsetParent || !k.parentNode.firstChild || k.parentNode.firstChild === k) return false;
      var r = document.createRange(); r.setStartBefore(k.parentNode.firstChild); r.setEndBefore(k);
      var rs = [].filter.call(r.getClientRects(), function (b) { return b.width > 2; });
      return rs.length && k.getBoundingClientRect().top >= rs[rs.length - 1].bottom - 4;
    }).forEach(function (k) { k.classList.add("fv-kr--dessous"); });
  }
  var t;
  function bientot() { cancelAnimationFrame(t); t = requestAnimationFrame(placer); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", placer); else placer();
  addEventListener("load", placer);
  addEventListener("resize", bientot);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(placer);
})();
